import { getAuthData } from '../authData';

export function getResumableHeaders() {
  return { 'Accept': '*/*', ...getAuthData() };
}
